<template>
	<div>
		<div :class="['codeblock', {'codeblock-expanded': expanded}]">
			<div class="codeblock-controls-anchor">
				<div class="codeblock-controls">
					<div class="codeblock-button" @click="switchExpand">
						<SvgIcon v-if="expanded" name="fold" title="Скрыть" fill="#eed" width="24" height="24"/>
						<SvgIcon v-else name="unfold" fill="#eed" title="Раскрыть" width="24" height="24"/>
					</div>
				</div>
			</div>{{data.text}}</div
		>
	</div>
</template>

<script>
import SvgIcon from '../SvgIcon';

export default {
	components: {
		SvgIcon,
	},

	props: {
		data: Object,
	},

	data: () => ({
		expanded: false,
	}),

	methods: {
		switchExpand(e) {
			e.preventDefault();
			this.expanded = !this.expanded;
			return false;
		},
	},
};
</script>

<style lang="less">
@import (reference) "~@/css/chat.less";

.codeblock {
	clear: both;
	display: block;
	font-family: monospace, 'sans-serif-monospace', 'Roboto Mono', 'Consolas', 'Ubuntu Mono', 'Courier New';
	white-space: pre-wrap;
	background-color: @color-chat-4;
	padding: 10px;
	border-radius: 2px;
	overflow: auto;
	max-height: 150px;
	margin: 5px;
	tab-size: 4;

	&.codeblock-expanded {
		max-height: none;
	}
}

.codeblock-controls-anchor {
	position: relative;

	> .codeblock-controls {
		display: inline-block;
		position: absolute;
		top: 0;
		right: 0;

		> .codeblock-button {
			display: inline-block;
			cursor: pointer;
		}
	}
}
</style>